<template>
  <div
    class="answers"
    data-toggle="buttons"
    :class="{ opacity: answered.answer_id !== null }"
  >
    <label
      role="button"
      :tabindex="index + 4"
      class="card-wrapper m-2"
      v-for="(answer, index) in answers"
      :key="answer.answer_id"
      :aria-pressed="answered.answer_id === answer.answer_id ? 'true' : 'false'"
      :class="{ active: answered.answer_id === answer.answer_id }"
      @keydown.enter.space="select(answer)"
      @click="select(answer)"
    >
      <div class="image-wrapper" aria-hidden="true">
        <img :src="answer.image || imgPlaceholder" :alt="answer.text" />
      </div>
      <div class="text">{{ answer.text }}</div>
    </label>
  </div>
</template>

<script>
const props = {
  question: {
    type: Object,
    required: true,
    validator: function(question) {
      if (!Array.isArray(question.answers)) return false

      return true
    },
  },
}

export default {
  props: props,
  data: () => {
    return {
      imgPlaceholder: 'https://via.placeholder.com/200x200',
    }
  },
  computed: {
    answered: function() {
      return this.question.answered || {}
    },
    answers: function() {
      return this.question.answers || []
    },
  },
  methods: {
    select(answer) {
      this.$emit('answer', answer)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.answers {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  .card-wrapper {
    border-radius: 8px;
    cursor: pointer;
    max-width: 150px;
    min-width: 150px;
    overflow: hidden;
    width: 22%;

    @media (max-width: 576px) {
      font-size: x-small;
      min-width: 115px;
    }

    &:hover {
      box-shadow: 0 3px 6px rgba(83, 92, 145, 0.5);
      .image-wrapper {
        background: var(--gray00);
      }
      .text {
        color: map-get($theme-colors, 'primary');
        font-weight: bold;
      }
    }

    .image-wrapper {
      align-items: center;
      background-color: var(--beige);
      display: flex;
      justify-content: center;
      width: 100%;

      img {
        width: 100%;
      }
    }

    .text {
      align-items: center;
      border: 1px solid rgba(83, 92, 145, 0.2);
      border-radius: 0 0 8px 8px;
      border-top: 0;
      color: map-get($theme-colors, 'gray03');
      display: flex;
      height: 65px;
      justify-content: center;
      padding: 5px;
      text-transform: uppercase;
      width: 100%;
    }

    input {
      display: none;
    }
  }

  &.opacity .card-wrapper {
    opacity: 0.65;

    &.active {
      opacity: 1;

      .text {
        color: map-get($theme-colors, 'primary');
        font-weight: bold;
      }
    }
  }
}
</style>
